import React, { useEffect, useState } from 'react';
import { Button, notification } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isAxiosError } from 'src/utils/typeGuardsAxios';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import useFetchReducer from 'src/hooks/useFetchReducer';
import ConfirmationCentered from 'src/components/common/ConfirmationCentered';
import { createBug } from '../../services/bugs.service';

type CreateBugButtonProps = {
  application: string;
  siteCode:string;
  className?: string;
};

const renderLink = (key: string) => (
  <a href={`https://ql2.atlassian.net/browse/${key}`} target="_blank">
    {key}
  </a>
);

export const CreateBugButton: React.FC<CreateBugButtonProps> = ({ application,siteCode, className }) => {
  const { user = null } = useAppStateContext();
  const [{ data: jiraTicket, error, loading }, refetch] = useFetchReducer<string>(null, []);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleConfirm = () => {
    if (user) {
      refetch(() => createBug(user.userEmail, application, siteCode));
    }
  };

  useEffect(() => {
    // we don't need to handle `axios` errors to avoid double notifications
    // since they're already handled in `src/api/axiosInstances/privateAxiosInstance.ts`
    if (error && !isAxiosError(error)) {
      notification.error({
        message: 'An error occurred.',
        description: `The Jira ticket couldn't be created. Please try again later...`,
        duration: 3,
      });
    }
  }, [error]);

  useEffect(() => {
    if (jiraTicket) {
      notification.success({
        message: 'Success',
        description: <>{renderLink(jiraTicket)} has been created</>,
        duration: null,
      });
    }
  }, [jiraTicket]);

  return (
    <>
      <Button className={className} loading={loading} disabled={loading} onClick={() => setIsModalOpen(true)}>
        {!loading && <FontAwesomeIcon icon={['fal', 'plus-circle']} size="lg" />}
        Create Bug
      </Button>

      <ConfirmationCentered
        title={'Are you sure you want to create a new Bug'}
        visible={isModalOpen}
        onAction={handleConfirm}
        setVisible={setIsModalOpen}
      />
    </>
  );
};
